import { uploadRestaurantLogoFileHttps } from "../../redux/restaurantsSlice";
import { store } from "../../redux/store";

interface UploadedImgDetails {
  fileExtention: string;
  formData: any;
}

export const uploadImage = async (
  uploadLogoFileExtetion: (data: { fileExtention: string }) => Promise<any>,
  uploadedImgDetails: UploadedImgDetails
): Promise<string> => {

  try {
    const uploadLogoFIleExtentionResult = await uploadLogoFileExtetion({
      fileExtention: uploadedImgDetails.fileExtention,
    });
    const imageUploadUrl = uploadLogoFIleExtentionResult.data.imageUploadUrl;

    await store.dispatch(
      uploadRestaurantLogoFileHttps({
        url: imageUploadUrl,
        body: uploadedImgDetails.formData,
        extention: uploadedImgDetails.fileExtention,
      })
    );
    return uploadLogoFIleExtentionResult.data.imageReference;
  } catch (error) {
    console.log("error in upload image", error);
    throw error;
  }
};
